module.exports = __webpack_public_path__ + "img/android.1a4b386f.png";